import { ConfigProvider, ThemeConfig } from "antd";
import { PropsWithChildren, ReactElement } from "react";

export interface AntDesignThemeProviderProps {
  theme: ThemeConfig;
}

export default function AntDesignThemeProvider({ children, theme }: PropsWithChildren<AntDesignThemeProviderProps>): ReactElement {
  return (
    <ConfigProvider theme={theme}>
      {children}
    </ConfigProvider>
  );
}
